import { NgModule, ModuleWithProviders } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UserHttpService } from "./user-http.service";
import { UserService } from "./user.service";
import { UteSmsDrawer } from './components/ute-sms-drawer/ute-sms-drawer.component';
import { UteRenameDrawer } from './components/ute-rename-drawer/ute-rename-drawer.component';
import { UteDeleteDrawer } from './components/ute-delete-drawer/ute-delete-drawer.component';
import { UteConfirmDrawer } from './components/ute-confirm-drawer/ute-confirm-drawer.component';

import { ComponentsModule } from '../components/components.module';

import { UteEmptyUserCard } from './components/ute-empty-user-card/ute-empty-user-card.component';
import { AuthenticationService } from '../core/authentication/authentication.service';
import { ErrorService } from '../core/error/error.service';
import { TranslateModule } from '@ngx-translate/core';
// import { FileTransfer } from '@ionic-native/file-transfer';

const components = [
  UteSmsDrawer,
  UteRenameDrawer,
  UteEmptyUserCard,
  UteDeleteDrawer,
  UteConfirmDrawer
];

let userService: UserService;

export function userFactory (
  userHttp: UserHttpService,
  authService: AuthenticationService,
  errorService: ErrorService
){
  if(!userService) {
    userService = new UserService(userHttp, authService, errorService);
  }
  return userService;
};

export function userFatcory (
  userHttp: UserHttpService,
  authService: AuthenticationService,
  errorService: ErrorService
) {
  if(!userService) {
    userService = new UserService(userHttp, authService, errorService);
  }
  return userService;
}

@NgModule({
  imports: [
    IonicPageModule,
    ComponentsModule,
    TranslateModule.forChild()
  ],
  providers: [
    UserHttpService,
    UserService
  ],
  declarations: components,
  exports: components
})
export class UserModule {
  public static forRoot() : ModuleWithProviders {
    return {
      ngModule: UserModule,
      providers: [
        UserHttpService,
        
        {
          provide: UserService,
          useFactory: userFatcory,
          deps: [UserHttpService, AuthenticationService, ErrorService]
        }
      ]
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/user/user.module.ts